import styled from 'styled-components'

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const IconWrapper = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
    path {
      fill: ${({ selected, theme }) =>
        selected ? theme.ds.colors.primary600 : theme.ds.colors.neutral900};
    }
  }
`

export const MenuItem = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 4px 16px;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  background-color: ${({ selected, theme }) =>
    selected ? theme.ds.colors.primary50 : 'transparent'};
  border-radius: 24px;
  transition: background-color 0.2s ease;

  span {
    color: ${({ selected, theme }) =>
      selected ? theme.ds.colors.primary600 : 'rgba(0, 0, 0, 0.90)'};
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    transition: color 0.2s ease;
  }
`
